// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { Dictionary } from "@insite/client-framework/Common/Types";
import translate from "@insite/client-framework/Translate";
import { NotificationsFollowedModel } from "@store/Framework/Types/ApiModels";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { CheckboxGroupComponentProps } from "@store/MobiusOverrides/CheckboxGroup/CheckboxGroup";
import React, { Dispatch, SetStateAction, useState } from "react";

interface OwnProps {
    fields: Dictionary<any>;
    preferences: { [key: string]: boolean } | Dictionary<any>;
    setValues: ((parameter: NotificationsFollowedModel) => void) | Dispatch<SetStateAction<NotificationsFollowedModel>>;
    extendedStyles?: NotificationPreferencesStyles;
}

type Props = OwnProps;

export interface NotificationPreferencesStyles {
    manageSubscriptionsCheckboxGroup?: CheckboxGroupComponentProps;
    manageSubscriptionsCheckbox?: CheckboxProps;
    checkBoxContainer?: GridContainerProps;
    checkBoxItem?: GridItemProps;
}

export const notificationPreferencesStyles: NotificationPreferencesStyles = {
    checkBoxItem: {
        width: [12, 12, 6, 12, 5],
    },
};

const NotificationPreferences = ({ fields, preferences, setValues, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(notificationPreferencesStyles, extendedStyles));

    return (
        <CheckboxGroup {...styles.manageSubscriptionsCheckboxGroup}>
            <GridContainer {...styles.checkBoxContainer}>
                {fields.followAccountActivationInvitation && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followAccountActivationInvitation: value,
                                });
                            }}
                            checked={preferences.followAccountActivationInvitation!}
                            data-test-selector="accountsettings_newfollowAccountActivationInvitationupdate"
                        >
                            {translate("New Greif+ Account Activation Invitations")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followNewFeature && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followNewFeature: value,
                                });
                            }}
                            checked={preferences.followNewFeature!}
                            data-test-selector="accountsettings_newfeatureupdate"
                        >
                            {translate("New Greif+ Features")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followNewPrice && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followNewPrice: value,
                                });
                            }}
                            checked={preferences.followNewPrice!}
                            data-test-selector="accountsettings_newpriceupdate"
                        >
                            {translate("New Prices")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followNewTec && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followNewTec: value,
                                });
                            }}
                            checked={preferences.followNewTec!}
                            data-test-selector="accountsettings_newtec"
                        >
                            {translate("Tax Exemption Certificates")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followUpcomingShipment && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followUpcomingShipment: value,
                                });
                            }}
                            checked={preferences.followUpcomingShipment!}
                            data-test-selector="accountsettings_upcomingshipments"
                        >
                            {translate("Upcoming Shipments")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followOrderShipped && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followOrderShipped: value,
                                });
                            }}
                            checked={preferences.followOrderShipped!}
                            data-test-selector="accountsettings_ordershipped"
                        >
                            {translate("Order Shipped")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followOrderPickup && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followOrderPickup: value,
                                });
                            }}
                            checked={preferences.followOrderPickup!}
                            data-test-selector="accountsettings_orderpickedup"
                        >
                            {translate("Order Picked up")}
                        </Checkbox>
                    </GridItem>
                )}
                {fields.followOrderChange && (
                    <GridItem {...styles.checkBoxItem}>
                        <Checkbox
                            {...styles.manageSubscriptionsCheckbox}
                            onChange={(_, value) => {
                                setValues({
                                    ...preferences,
                                    followOrderChange: value,
                                });
                            }}
                            checked={preferences.followOrderChange!}
                            data-test-selector="accountsettings_orderorderchange"
                        >
                            {translate("Changes to Upcoming Orders")}
                        </Checkbox>
                    </GridItem>
                )}
            </GridContainer>
        </CheckboxGroup>
    );
};

export default NotificationPreferences;
